require('./vue-toasted');

window.yagankar = require('./src/yagankar').default;
import Echo from 'laravel-echo';
import yagankar from './src/yagankar';

window.NProgress = require('nprogress');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        // Handle global session timeout error.
        if (error.response.status === 401) {
            window.yagankar.bus.emitEvent('session-expired');
        }

        // Handle global validation errors and exceptions.
        if (error.response && error.response.status === 422) {
            yagankar.bus.emit('validation-error-occured', error.response.data);
        }

        return Promise.reject(error);
    }
);

window.io = require('socket.io-client');

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: `${location.hostname}:${App.echoServer.port}`,
    transports: ['websocket', 'polling', 'flashsocket'] // Fix CORS error!
});
